import React, { useState, useEffect } from 'react'
import { CircularSpinner } from '../components/CircularSpinner'
import dynamic from 'next/dynamic';
const Modal = dynamic(() => import('./Modal'), {
  ssr: false, 
});

export const CookieWrapper = ({ children }) => {
  const [isCookieEnble, setCookieEnble] = useState('loader')

  useEffect(() => {
    setCookieEnble(navigator?.cookieEnabled)
  }, [])
  return (
    <>
      {/* {isCookieEnble === 'loader' && (
        <div className="flex h-screen items-center justify-center">
          <CircularSpinner isTralationPresent={false} />
        </div>
      )} */}
      {isCookieEnble == true && children}

      {isCookieEnble == false && (
        <Modal isOpen={true} onClose={() => {}}>
          <div className="mx-lg w-[350px] space-y-4 rounded-xs bg-white p-14 shadow-default">
            <div className="text-lg">We can't sign you in</div>
            <div className="text-base">
              Your browser is currently set to block cookies. You need to allow cookies to use this
              service.
            </div>
            <div className="text-base">
              Cookies are small text files stored on your computer that tell us when you're signed
              in. To learn how to allow cookies, check the online help in your web browser.
            </div>
          </div>
        </Modal>
      )}
    </>
  )
}
